// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__22rML","title":"ClientInsurance_title__nbOtE","itemText":"ClientInsurance_itemText__2-mmC"};